import { Report, ReportData, ReportElement, ReportElementType, ReportScope } from '../types';
import { ReportDataResponse, ReportElementResponse, ReportResponse } from '../types/dto';

export const mapElement = (dto: ReportElementResponse): ReportElement => ({
  id: dto.id,
  type: dto.type as ReportElementType,
  position: dto.position,
  reportType: dto.reportType ?? null,
  columns: dto.columns ?? [],
  groupBy: dto.groupBy ?? [],
  pivotDimension: dto.pivotDimension ?? null,
  sortBy: dto.sortBy ?? null,
  sortOrder: dto.sortOrder ?? null,
  config: dto.config,
});

export const mapReport = (dto: ReportResponse): Report => ({
  id: dto.id,
  name: dto.name,
  scope: dto.scope as ReportScope,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
  elements: dto.elements.map(mapElement),
});

export const mapReportData = (dto: ReportDataResponse): ReportData => ({
  measures: dto.measures,
  dimensions: dto.dimensions,
  pivotDimension: dto.pivotDimension,
  pivotValues: dto.pivotValues,
  rows: dto.rows.map(columns => ({ columns })),
  totalsRow: dto.totalsRow,
  groupSummaryRows: dto.groupSummaryRows,
  totalCount: dto.totalCount,
  averageValue: dto.averageValue,
});
